import { v4 as uuidv4 } from "uuid";

// 获取32位UUID
export default function uuid() {
    return uuidv4().replace(/-/g, "");
}